/** Chart series slots: fixed order, never cycled. Series past this fold into "Other". */
export const SERIES_SLOTS = 6
export const seriesColor = (index: number): string =>
  index < SERIES_SLOTS ? `var(--series-${index + 1})` : "var(--series-other)"
